export const outerStyle: React.CSSProperties = {
  width: '100vw',
  minHeight: '100vh',
  background: 'url("http://rescloud.ediblearrangements.com/image/private/f_auto/q_auto/v1748371857/Creative-Marketing/site_support/MyEdible_pattern_Desktop_Login.png") center center / cover no-repeat',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  margin: 0,
  padding: 0,
  position: 'fixed' as const,
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 0,
  overflowX: 'hidden',
  overflowY: 'auto'
};

export const loginCardStyle: React.CSSProperties = {
  width: 'fit-content',
  height: 'fit-content',
  background: 'white',
  boxShadow: '0px 7px 15px rgba(0, 0, 0, 0.16)',
  borderRadius: 8,
  padding: 'clamp(12px, 5vw, 32px) clamp(24px, 1.5vw, 64px)',
  display: 'flex',
  flexDirection: 'column' as const,
  alignItems: 'center',
  justifySelf: 'center',
  gap: 32,
  boxSizing: 'border-box' as const,
};

export const headerSectionStyle: React.CSSProperties = {
  alignSelf: 'stretch',
  display: 'flex',
  flexDirection: 'column' as const,
  gap: 'max(5%, 16px)',
};

export const titleStyle: React.CSSProperties = {
  fontFamily: 'Poppins, sans-serif',
  fontSize: 'clamp(12px, 7vw, 34px)',
  fontWeight: 500,
  textTransform: 'capitalize' as const,
  lineHeight: 'clamp(14.8px, 8.6vw, 42px)',
  letterSpacing: 0.09,
  color: '#2E2E2E',
  margin: 0,
};

export const redSpanStyle: React.CSSProperties = {
  color: '#E10600',
};

export const subtitleStyle: React.CSSProperties = {
  color: '#2E2E2E',
  fontSize: 'clamp(5.6px, 3.3vw, 16px)',
  fontFamily: 'Poppins, sans-serif',
  fontWeight: 500,
  lineHeight: 'clamp(5px, 5vw, 24px)',
};

export const formSectionStyle: React.CSSProperties = {
  alignSelf: 'stretch',
  paddingBottom: 8,
  display: 'flex',
  flexDirection: 'column' as const,
  gap: 24,
};

export const fieldGroupStyle: React.CSSProperties = {
  alignSelf: 'stretch',
  display: 'flex',
  flexDirection: 'column' as const,
  gap: 8,
};

export const fieldLabelStyle: React.CSSProperties = {
  color: '#2E2E2E',
  fontSize: 'clamp(3.5px, 2.1vw, 10px)',
  fontFamily: 'Poppins, sans-serif',
  fontWeight: 400,
  textTransform: 'uppercase' as const,
  lineHeight: 'clamp(5px, 3.5vw, 22px)',
  letterSpacing: 1,
};

export const inputStyle: React.CSSProperties = {
  alignSelf: 'center',
  width: '100%',
  background: 'white',
  borderRadius: 8,
  outline: '1px #5C5C5C solid',
  outlineOffset: -1,
  border: 'none',
  padding: 'clamp(5px, 5vw, 14px) clamp(4.4px, 4.4vw, 8px)',
  fontSize: 'clamp(4.9px, 2.9vw, 14px)',
  fontFamily: 'Poppins, sans-serif',
  color: '#2E2E2E',
  marginTop: 2,
};

export const errorMsgStyle: React.CSSProperties = {
  color: '#E10600',
  fontSize: 'clamp(4.6px, 2.7vw, 13px)',
  fontFamily: 'Poppins, sans-serif',
  marginTop: -8,
  marginBottom: 8,
};

export const loginButtonStyle: React.CSSProperties = {
  alignSelf: 'stretch',
  padding: '11px 12px',
  background: '#E10600',
  borderRadius: 32,
  border: 'none',
  color: '#fff',
  fontSize: 'clamp(5.3px, 3.1vw, 15px)',
  fontFamily: 'Poppins, sans-serif',
  fontWeight: 600,
  textTransform: 'capitalize' as const,
  lineHeight: '26px',
  letterSpacing: 0.46,
  cursor: 'pointer',
  transition: 'background 0.2s',
};

export const helpLinkStyle: React.CSSProperties = {
  padding: '10px 0',
  textAlign: 'center' as const,
  color: '#E10600',
  fontSize: 'clamp(5.3px, 3.1vw, 15px)',
  fontFamily: 'Poppins, sans-serif',
  fontWeight: 600,
  lineHeight: 'clamp(5px, 3.5vw, 26px)',
  letterSpacing: 0.46,
};

export const loginCardHeader: React.CSSProperties = {
  width: '100%',
  display: 'flex',
  flexDirection: 'column' as const,
  alignItems: 'flex-start',
  gap: 16,
  marginBottom: 8,
};

export const loginCardTitle: React.CSSProperties = {
  fontFamily: 'Poppins, sans-serif',
  fontSize: 'clamp(8.5px, 4.9vw, 24px)',
  fontWeight: 500,
  color: '#2E2E2E',
  textTransform: 'capitalize' as const,
  lineHeight: 'clamp(10px, 5.5vw, 36px)',
  margin: 0,
};

export const loginCardSubtitle: React.CSSProperties = {
  color: '#2E2E2E',
  fontSize: 'clamp(4.9px, 2.9vw, 14px)',
  fontFamily: 'Poppins, sans-serif',
  fontWeight: 400,
  lineHeight: '20px',
  marginBottom: 8,
};

export const loginButtonSecondary: React.CSSProperties = {
  alignSelf: 'stretch',
  padding: '11px 12px',
  background: '#FFFFFF',
  border: '1px solid #E10600',
  borderRadius: 32,
  color: '#E10600',
  fontSize: 'clamp(5.3px, 3.1vw, 15px)',
  fontFamily: 'Poppins, sans-serif',
  fontWeight: 600,
  textTransform: 'capitalize' as const,
  lineHeight: '26px',
  letterSpacing: 0.46,
  cursor: 'pointer',
  transition: 'background 0.2s',
};

export const loginFieldError: React.CSSProperties = {
  color: '#E10600',
  fontSize: 'clamp(4.2px, 2.5vw, 12px)',
  fontFamily: 'Poppins, sans-serif',
  marginTop: 4,
  marginBottom: 4,
};
